// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ConfirmationModal-cls1__c6e7619aa56dcbddd785{/*!*/}.ConfirmationModal-cls2__e77d65211028190eeea7{--size: 48px;height:var(--size);margin-right:-12px;padding:0;width:var(--size)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ConfirmationModal-cls1__c6e7619aa56dcbddd785",
	"cls2": "ConfirmationModal-cls2__e77d65211028190eeea7 ConfirmationModal-cls1__c6e7619aa56dcbddd785"
};
export default ___CSS_LOADER_EXPORT___;
